import type { FunctionComponent, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';
import Flex from '../Flex';
import type { FlexContainerProps } from '../Flex';
import type { BaseProps, ForwardProps } from '../../types';
import { StyledPopover } from '../Popover';

import { StyledCard } from './Card';

export interface CardFooterProps extends BaseProps {
  /** [justify-content](https://css-tricks.com/almanac/properties/j/justify-content/) */
  justify?: FlexContainerProps['justify'];
}

export const StyledCardFooter = styled.footer(({ theme }) => {
  return css`
    ${StyledPopover} &, &:not(${StyledCard} ${StyledCard} > &) {
      padding: calc(1.5 * ${theme.base.spacing}) calc(${theme.components.card.padding} * 2);

      @media (width < ${theme.base.breakpoints.sm}) {
        padding: ${theme.base.spacing} calc(${theme.components.card.padding} * 1.5);
      }
    }
  `;
});

StyledCardFooter.defaultProps = defaultThemeProp;

const CardFooter: FunctionComponent<CardFooterProps & ForwardProps> = (
  props: PropsWithChildren<CardFooterProps>
) => {
  const { children, justify, ...restProps } = props;

  return (
    <Flex
      as={StyledCardFooter}
      container={{
        wrap: 'wrap',
        alignItems: 'center',
        justify
      }}
      {...restProps}
    >
      {children}
    </Flex>
  );
};

export default CardFooter;
